import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParamsKeys, RestURLsEnum } from '@app/model/http-request-enums';
import { PaymentRequest, PaymentResponse, Transaction } from '@app/model/payments/payments.model';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root'
})
export class PaymentService {

    private baseUrl: string = environment.csBaseURL + RestURLsEnum.PAYMENTS;
    private sessionsUrl: string = environment.csBaseURL + RestURLsEnum.SESSIONS;

    constructor(private httpClient: HttpClient) { }

    getGuestPayment$(request: PaymentRequest) {
        const url = this.baseUrl + '/guest';
        return this.httpClient.post<PaymentResponse>(url, request);
    }

    getTransactionBySessionId$(sessionId: string, verification: string) {
        const url = this.sessionsUrl + `/${sessionId}/transaction`;
        const params: HttpParams = new HttpParams()
            .set(ParamsKeys.VERIFICATION, verification);
        return this.httpClient.get<Transaction>(url, { params });
    }
}
